import cronJobPayloadSchema from 'root/src/shared/descriptions/endpoints/schemas/requestSchemas/cronJobPayloadSchema';
import { pointsEndpointIds } from 'root/src/shared/points/points.constants';
export const awardPointsEndpoint = {
    [pointsEndpointIds.AWARD_POINTS]: {
        payloadSchema: cronJobPayloadSchema,
        isCron: true,
    },
};
